import styled from 'styled-components';

export const Logo = styled.img`
  width: 79px;
  height: 18px;
`;
